import * as React from "react"
import { motion } from "framer-motion"
import { Link } from "gatsby"

import { getTheme } from "../components/themer"

import FeatherIcon from "../components/featherIcon"

const SpeakingPage = props => {
  let theme = getTheme()

  return (
    <motion.div
      style={{
        height: "100%",
        width: "100%",
        paddingLeft: "25%",
        paddingRight: "25%",
        paddingTop: "20%",
      }}
    >
      <Link to="/">
        <motion.div
          className={"page2Link"}
          style={{ backgroundColor: theme.textColor }}
        ></motion.div>
      </Link>
      <motion.div id={"speaking-container"}>
        <motion.h1 style={{ color: theme.textColor }}>Speaking</motion.h1>

        <motion.h4 style={{ color: theme.textColor, fontWeight: 600 }}>
          I've had a chance to speak at different events, on topics covering
          anything from design to development.
        </motion.h4>
        <motion.h4 style={{ color: theme.textColor, fontWeight: 600 }}>
          I've learned a lot the past few years in the product industry, and I'm
          here to share some thoughts about what has been done, what we should
          continue to do, and what could be better.
        </motion.h4>
        <motion.h4 style={{ color: theme.textColor, fontWeight: 800 }}>
          Previous talks
        </motion.h4>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          - Product Design Meetup 2018 (Gent, BE)
        </motion.p>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          - Squarespace Meetup 2019 (New York, NY)
        </motion.p>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          - The Power of Prototyping 2019 (Eindhoven, NL)
        </motion.p>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          - Framer Meetup 2019 (Amsterdam, NL)
        </motion.p>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          <a href="https://www.framer.com/loupe/" target="_blank">
            - Loupe Design Conference 2019 (Amsterdam, NL)
          </a>
        </motion.p>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          - Farfetch Meetup 2020 (London, UK)
        </motion.p>
        <motion.p style={{ color: theme.textColor, marginBottom: 10 }}>
          - Awwwards X Adyen 2020 (Amsterdam, NL)
        </motion.p>
      </motion.div>
      <motion.div style={{ display: "flex", paddingTop: 20 }}>
        <a
          href="mailto:addisonschultz0@gmail.com?subject=Interested in speaking at our
        event?"
        >
          <h4 style={{ color: theme.textColor }}>Get in touch</h4>
        </a>
      </motion.div>
    </motion.div>
  )
}

export default SpeakingPage
